import LeftArrowIcon from "@assets/images/left-arrow.svg?react";
import classNames from "classnames";

import "./style.scss";

interface ArrowButtonProps {
	label: string;
	onClick?: () => void;
	className?: string;
	align?: "left" | "right";
}

const ArrowButton = ({ onClick, label, className, align = "left" }: ArrowButtonProps) => {
	return (
		<button
			className={classNames("arrow-button", {
				[className ?? ""]: className,
				[align]: align,
			})}
			onClick={onClick}
		>
			<LeftArrowIcon />
			<span>{label}</span>
		</button>
	);
};

export default ArrowButton;
